import type { ReactNode } from 'react';
import { useT } from '@/i18n/LanguageContext';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const t = useT();

  return (
    <div className="auth-page min-h-screen flex flex-col items-center justify-center px-4 py-12">
      {/* Logo */}
      <img
        src="/reevol-dark.png"
        alt="Reevol"
        className="h-20 sm:h-24 mb-10"
      />

      {/* Content */}
      <div className="w-full max-w-md text-center">
        {children}
      </div>

      {/* Footer */}
      <p className="mt-8 text-sm text-[#9A9A9A]">
        {t.common.termsFooter}
      </p>
    </div>
  );
}
